import { Application } from "@hotwired/stimulus"
import PasswordValidationController from "../controllers/password_validation_controller"

const application = Application.start()
application.debug = false

application.register('password-validation', PasswordValidationController)
